// ESM-Huelle um lib/scripts/pos/CLS_CDataImport.js (Phase 4, Welle 4a).
// Prototype-Stil bleibt vorerst.
function CDataImport() {
    //this.masterData = "var/db/import/MasterData";
    this.importDir = "var/db/import/";
    this.importFile = "";
    this.mainTimeout = 15 * 1000 / 250; // seconds
    this.mainTimeoutMultip = 8; // 8x so lange wie Timeout
    this.TimeoutCounter = this.mainTimeoutMultip;

    this.popUpTimeoutId = null;
    this.importActive = false;
    this.importBonId = null;
    this.updatedb = "var/db/import/UpdateDB";
    this.CVSUpdateHour = 5; // at 5 in the morning
}



CDataImport.prototype.manualImportData = function(component, parameters) {
    var me = POS.DataImport || this;
    // existsFile/masterData gibt es in CDataImport nicht (auch nicht im
    // Legacy-Stand der Produktivkassen) - der Klick aufs Import-Symbol warf
    // bisher nur einen Fehler ins Log. Importiert wird ohnehin vom Server
    // (MSG:importdata). Darum die vorhandene Meldung (Nutzer 30.9.2026).
    if (typeof me.existsFile != "function") {
        POS.message.show(POS.lang.getText("MESSAGES", "NO_IMPORT_FILE"), "info", "OK");
        return;
    }
    //me.masterData = "var/db/import/MasterData";

    if (me.existsFile("master")) {
        me.importFile = me.masterData;
        var text = POS.lang.getText("MESSAGES", "CONF_IMPORT");
        POS.message.show(text, "question", "YESNO", me, me.doImportData);
    } else if (me.existsFile("master_le")) {
        me.importFile = me.masterData_LE;
        var text = POS.lang.getText("MESSAGES", "CONF_IMPORT");
        POS.message.show(text, "question", "YESNO", me, me.doImportData);
    } else {
        var text = POS.lang.getText("MESSAGES", "NO_IMPORT_FILE");
        POS.message.show(text, "info", "OK");
    }
}

CDataImport.prototype.doImportData = function(me, result) {
    if (result != "YES")
        return;

    var me = POS.DataImport;
    //  me.masterData = "var/db/import/MasterData";
    me.executeImport(me);
}




CDataImport.prototype.executeImport = function(me) {
    

	if (me.importActive ) return;
	POS.blockedStatus = true;
    me.importActive = true;

    var d = new Date();
    if (POS.sessions.currentSession != 0) {
        var userLogin = POS.sessions.openSessions[POS.sessions.currentSession].userProps.Login;
        var userName = "'" + POS.sessions.openSessions[POS.sessions.currentSession].userProps.Name + "'";
    } else {
        var userLogin = 0;
        var userName = "'0'";
    }

    var sql = "INSERT INTO BON " +
        "(Closed, Start, End, POS_ID, U_ID, UName, Cancelled, Type, Exported) " +
        "VALUES (0, " + (d / 1000).toFixed(0) + ", 0, " + POS.POSId + ", " +
        userLogin + ", " + userName + ", 0, 'MIM', 0)";

    $.when(POS.SQLiteCon.execute(sql)).then(function() {
        $.when(POS.SQLiteCon.lastInsertId()).then(function(id) {
            me.importBonId = id;
            var text = POS.lang.getText("MESSAGES", "IMPORT_MODE");
            POS.hourGlass.show(text, false, me.importMasterData);
//		POS.hourGlass.show(text, false);
        });
    });

}

CDataImport.prototype.importMasterData = function(lightMode) {

    var me = POS.DataImport;

    try {
        me.importData = fs.readFileSync(me.importFile).toString(); //.replace(/(\r\n|\n|\r)/gm,"");
    } catch (e) {
        POS.hourGlass.hide();
        POS.blockedStatus = false;
        me.importActive = false;
        return false;
    }


    setTimeout(me.doImportMasterData, 0, me, 0, lightMode);
}

CDataImport.prototype.doImportMasterData = function(me, i, lightMode) {

    me.importData = me.importData.split(';\n');
    var count = me.importData.length;
    var f = Math.round(i / count * 100);

    if (!lightMode) {
        var text = POS.lang.getText("MESSAGES", "DATA_IMPORT_1") + " " +
            f + POS.lang.getText("MESSAGES", "DATA_IMPORT_2");
        POS.hourGlass.show(text, null, null);
    }

    /*me.sqlite3 = require('sqlite3');
    var db = new me.sqlite3.Database("var/db/POS.db"); //,sqlite3.OPEN_READWRITE | sqlite3.OPEN_CREATE);*/
    //POS.SQLiteCon.locked = true;
    var def = $.Deferred();
    var c = i;
    var percent = 1;
    var iterator = function it(c) {

        if (c < count) {
            try {
		 $.when(POS.SQLiteCon.execute(me.importData[c].replace(/^(\r\n|\n|\r)/))).then(function() {
                //db.run(me.importData[c].replace(/^(\r\n|\n|\r)/, ""), function(err, row1) {
                    if (c > (percent * count / 100)) {
                        POS.hourGlass.hide();
                        var text = POS.lang.getText("MESSAGES", "DATA_IMPORT_1") + " " +
                            percent + POS.lang.getText("MESSAGES", "DATA_IMPORT_2");
                        POS.hourGlass.show(text, null, null, true);
                        percent = Math.round(c / count * 100);
                    }
                    iterator(c + 1);
                    return;
                });
            } catch (e) {
                if (!lightMode) {
                    POS.hourGlass.hide();
                    log.add(1, "Error", "Import von " + me.importFile + " fehlgeschlagen", e);
                    text = POS.lang.getText("MESSAGES", "IMPORT_ERROR");
                    POS.message.show(text, "critical", "OK", null, null);
                } else {
                    log.add(1, "Error", "Import von " + me.importFile + " fehlgeschlagen: >> " + me.importData[c] + " <<", e);
                }
                c--;
                iterator(c + 1);
                return;
            }
        } else {
            def.resolve(c);
            return;
        }

    };
    iterator(i);
    $.when(def).then(function(c) {
        i = c;
/*        if (db.open == true) {
            db.close();
        }*/
   //     POS.SQLiteCon.unlock();
        if (c >= me.importData.length) {
            if (!lightMode) {
                text = POS.lang.getText("MESSAGES", "IMPORT_SUCCESS");
                POS.hourGlass.show(text, null, null);
            }
            setTimeout(me.doStopImport, 500, me, true, lightMode);
        } else
            setTimeout(me.doImportMasterData, 500, me, i, lightMode);

    });
}


CDataImport.prototype.doStopImport = function(me, eraseFile, lightMode) {
    me.stopImport(eraseFile, lightMode);
}

CDataImport.prototype.stopImport = function(eraseFile, lightMode) {
    //if (!lightMode) {
    POS.hourGlass.hide();
    POS.DataImport.reDrawAllMainPOS();
    //}
    log.add(1, "Info", "Import beendet:");
    POS.blockedStatus = false;

    if (eraseFile && fs.existsSync(POS.DataImport.importFile))
        fs.unlinkSync(POS.DataImport.importFile); //.deleteFile();

    if (POS.DataImport.importBonId) {
        var d = new Date();
        var sql = "UPDATE BON SET End = " + (d / 1000).toFixed(0) + " WHERE BON_ID = " + POS.DataImport.importBonId;
        POS.SQLiteCon.execute(sql);
    } else
        POS.DataImport.importBonId = null;

    POS.DataImport.importActive = false;
}

CDataImport.prototype.reDrawAllMainPOS = function() {
    // Je Sitzung ein eigener Aufruf (forEach statt for-in + var): die
    // Callbacks sahen vorher ALLE die zuletzt gesetzte Sitzung "Main".
    Object.keys(POS.sessions.openSessions).forEach(function (j) {
        if (j == 0)
            return;
        var Main = POS.sessions.openSessions[j];
        if (!Main)
            return;

        if (typeof Main.userProps["COL"] != "undefined" && Main.userProps["COL"] == 0)
            return;

        // React-Hauptmaske (CMainPOS): neu laden und rendern. Der alte Weg
        // unten (prepare + reDraw auf dem Panel) warf dort (Code-Suche 30.9.2026).
        if (typeof Main.produkteNeuLaden == "function") {
            $.when(Main.produkteNeuLaden()).done(function () {
                if (!POS.isPOSOpened)
                    Main.components.prodSelect.setEnabled(false);
            });
            return;
        }

        $.when(Main.makeProdCatButtons()).then(function(ProdCatButtons) {
            Main.components.prodSelect.tabs = ProdCatButtons;

            var its = new Array(Main.components.prodSelect.tabs.length);
            var iterator = function it(i) {
                if (i < its.length) {
                    $.when(Main.makeProdButtons(i)).then(function(ProdButtons) {
                        its[i] = ProdButtons;
                        iterator(i + 1);
                        return;
                    });

                } else {

                    Main.components.prodSelect.items = its;

                    Main.components.prodSelect.prepare();
                    $.when(Main.components.prodSelect.reDraw()).done(function() {

                        if (!POS.isPOSOpened)
                            Main.components.prodSelect.setEnabled(false);
                        return;
                    });
                }

            };
            iterator(0);

        });
    });
}


CDataImport.prototype.checkCVSTime = function(me) {

    var d = new Date();
    var hour = d.getHours();

    if (hour == me.CVSUpdateHour)
        me.getLastCVS();
}


CDataImport.prototype.checkIntegrity = function(file) {
    //this.masterData.readOpen();
    var content = fs.readFileSync(file).toString().split(';\n');
    //var content = this.masterData.readAll().split("\n");

    var beginTx = false;
    var endTx = false;

    //for (var i = 0; i < content.length; i++) {
    if (content.length > 3) {
        if ((content[0].indexOf("BEGIN TRANSACTION") > -1) || (content[1].indexOf("BEGIN TRANSACTION") > -1) || (content[2].indexOf("BEGIN TRANSACTION") > -1))
            beginTx = true;
        //else
        if ((content[content.length - 1].indexOf("COMMIT") > -1) || (content[content.length - 2].indexOf("COMMIT") > -1) || (content[content.length - 3].indexOf("COMMIT") > -1))
            endTx = true;
        //}
    } else {
        fs.unlink(file);
    }
    var ok = (beginTx & endTx);

    if (!ok) {
        log.add(4, "Error", "Could not import data... Corrupted file?");
        return false;
    }

    return true;
}

export { CDataImport };
